import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const TermsAndConditions = (props) => {

    const Terms = [
        {
            tittle: 'Event Cancellation',
            details: 'FoBK holds the right to cancel the event without prior notice if weather conditions are not satisfactory on the event day, or for any unforeseeable circumstances',
        },
        {
            tittle: 'Indemnity Agreement',
            details: 'I hereby agree not to claim any damages or take any form of legal action against Friends of Bukit Kiara (FoBK) or its members/partners in the event of any accident, injury, loss of property and/or death arising from this event',
        },
        {
            tittle: 'Privacy Policy',
            details: <span>I accept the conditions of the Privacy Policy provided <a href='https://docs.google.com/document/d/1ThQNAsybXakeZpoqaG5OOs2zV0Z9i5njMpwCCbUtveg/edit?usp=sharing' target="_blank" rel="noreferrer">here</a></span>
        }
    ]

    return (
        <div>
            <Modal isOpen={props.modal} toggle={props.toggle}>
                <ModalHeader toggle={props.toggle}>Terms & Conditions</ModalHeader>
                <ModalBody>
                    {Terms.map(({ tittle, details }) => <span>
                        <b>{tittle}</b><br />
                        {details}
                        <br /><br />
                    </span>)}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={props.acceptTermsAndConditions}>Accept</Button>{' '}
                    <Button color="secondary" onClick={props.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default TermsAndConditions;